export const PARAM_KEY_RISK_ZONES_TAB = "riskZonesTab"
export const PARAM_KEY_RISK_ZONES_YEAR = "riskZonesYear"
export const PARAM_KEY_RISK_ZONES_ACTIVE_LAYER = "riskZonesActiveLayer"
export const RISK_ZONES_DEFAULT_ACTIVE_LAYER = "riskZones"